import { ChargeTypes } from '@enums/charge-types';

/**
 * Payload to update the billing info of the Recurly subscription an order belongs to.
 */
export abstract class AbstractSubscriptionBillingUpdateRequest {
  public payment_type: ChargeTypes;

  protected constructor(paymentType: ChargeTypes) {
    this.payment_type = paymentType;
  }
}
